<unity-page-container [contentHeader]="$contentHeader()" [isLoading]="false">
  @let formGroup = $formGroup();
  <unity-card-new-shared actionName="Create" [formGroup]="formGroup" [formLoading]="$formLoading()" (submitEvent)="onSubmit()">
    <unity-dropdown-agency-control
      displayName="Business Partner"
      description="Select the business partner for which you are creating a new role."
      [control]="formGroup.controls.agency_id"
      (selectionChangeEvent)="onAgencySelection($event)" />
    <unity-textbox-control
      displayName="Role Name"
      description="Enter the name of the role within the organization (e.g., Manager, Analyst)"
      [control]="formGroup.controls.name" />
    <unity-textbox-control
      displayName="Description"
      description="Describe the role's purpose or function."
      [control]="formGroup.controls.description" />
    @let agencyId = $selectedAgencyId();
    @if (agencyId) {
      <unity-dropdown-control
        displayName="Parent Role"
        description="Choose an existing role as the parent for this role. The new role will inherit its parent's permissions and cannot have more permissions than the parent."
        [control]="formGroup.controls.parent_role_id"
        [values]="$inputRoles()?.data ?? []" />
    }
  </unity-card-new-shared>
</unity-page-container>
